import React from 'react';
import { observer } from 'mobx-react';
import { useStore } from '../../../store';
import { DataGrid } from '../../../components';

const Table = () => {
  const {
    HistoryStore: {
      gridOption: {
        columns,
        rows,
        totalCount,
        loading,
        page,
        rowsPerPage,
      },
      onPageSizeChange,
      onPageChange
    }
  } = useStore();
  return (
    <DataGrid 
      rows={rows} 
      columns={columns} 
      totalCount={totalCount} 
      loading={loading}
      page={page}
      // rowHeight={100}
      rowsPerPage={rowsPerPage}  
      onPageSizeChange={onPageSizeChange}
      onPageChange={onPageChange}
    />
  );
};

export default observer(Table);
